import { Navigate, useSearchParams } from "react-router-dom";

// The Investor Panel has merged into the Client Portal — keep old /account?tab= links working.
const MAP = { portfolio: "/client/portfolio", kyc: "/client/kyc", alerts: "/client/alerts", consult: "/client/consult", enquiries: "/client/enquiries", profile: "/client/profile" };

export default function Account() {
  const [params] = useSearchParams();
  return <Navigate to={MAP[params.get("tab")] || "/client/dashboard"} replace />;
}
